import { Component } from "react";
import EditButton from "../../components/ui/button/EditButton";
import DeleteButton from "../../components/ui/button/DeleteButton";
import Radio from "../../components/ui/Radio";
import TitleBar from "../../components/ui/TitleBar";

import "./style.scss";
import RectButton from "../../components/ui/button/RectButton";
import Book from "../../components/Book";
import EditAddressPopup from "../../components/Popup/EditAddressPopup";
import AppContext from "../../contexts/AppContext";

class AddressBook extends Component {
    static contextType = AppContext;
    render() {
        return (
            <>
                <div className="full-container address-book">
                    <div className="section-box my-address">
                        <TitleBar title="Return Address" />
                        <div className="box">
                            <div className="row address-row">
                                <div className="row lock not-expand address">
                                    <Radio label="4206 Spruce Street, Philadelphia, PA, 19104" />
                                    <div className="row lock not-expand actions">
                                        <EditButton onClick={() => this.context.setPopup(<EditAddressPopup />)} />
                                        <DeleteButton />
                                    </div>
                                </div>
                                <RectButton text="ADD NEW" onClick={() => this.context.setPopup(<EditAddressPopup />)} />
                            </div>
                        </div>
                    </div>

                    <div className="section-box book-box">
                        <TitleBar title="Address Book" />
                        <Book className="box" editing={true}>
                            {{ name: "Ari Kaplan", address: "Philadelphia, PA, 19104" }}
                            {{ name: "Ari Kaplan 2", address: "Philadelphia, PA, 19104" }}
                            {{ name: "Ari Kaplan 3", address: "Philadelphia, PA, 19104" }}
                            {{ name: "Ari Kaplan 4", address: "Philadelphia, PA, 19104" }}
                            {{ name: "Ari Kaplan 5", address: "Philadelphia, PA, 19104" }}
                            {{ name: "Ari Kaplan 6", address: "Philadelphia, PA, 19104" }}
                            {{ name: "Ari Kaplan 7", address: "Philadelphia, PA, 19104" }}
                            {{ name: "Ari Kaplan 8", address: "Philadelphia, PA, 19104" }}
                            {{ name: "Ari Kaplan 9", address: "Philadelphia, PA, 19104" }}
                            {{ name: "Ari Kaplan 10", address: "Philadelphia, PA, 19104" }}
                            {{ name: "Ari Kaplan 11", address: "Philadelphia, PA, 19104" }}
                            {{ name: "Ari Kaplan 12", address: "Philadelphia, PA, 19104" }}
                        </Book>
                    </div>
                </div>
            </>
        )
    }
}

export default AddressBook;